/*global jQuery, google */
(function($) {

  'use strict';

    var initMap,
    addMarker,
    removeMarker,
    showMarkerTooltip,
    map,
    infowindow,
    gdc,
    directionsDisplay,
    directionsService,
    calcRoute;

  var stylesArray = [];

  addMarker = function(place, contentString, image) {
    var marker = new google.maps.Marker({
      position: place.position,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: image
    });

    place.marker = marker;

    google.maps.event.addListener(marker, 'click', function() {
        infowindow.setContent(contentString);
        infowindow.open(map, marker);
    });

  };

  removeMarker = function(place) {
    if (place.marker) {
      place.marker.setMap(null);
      place.marker = null;
    }

  };

  showMarkerTooltip = function(place) {
    infowindow.setContent(place.tooltip);
    infowindow.open(map, place.marker);
  };


  initMap = function(mapContainer, myzoom, mylocations, tipo=null) {

    map = new google.maps.Map(mapContainer, {
      styles: stylesArray,
      zoom: myzoom,
      center: new google.maps.LatLng( mylocations[0][0], mylocations[0][1]),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false
    });
    directionsDisplay = new google.maps.DirectionsRenderer();
    directionsDisplay.setMap(map);
    directionsService = new google.maps.DirectionsService();

    infowindow = new google.maps.InfoWindow();



    var i, locations = mylocations;

    for (i = 0; i < locations.length; i++) {
      if (tipo !== null) {
        if (locations[i][4] === undefined) locations[i][4] =  imageGreen;
        if (locations[i][2] === tipo) {
          gdc = {
            position: new google.maps.LatLng(
              locations[i][0], locations[i][1]
            )
          };
          addMarker(gdc, locations[i][3], locations[i][4]);
        }
      } else {
        gdc = {
          position: new google.maps.LatLng(
            locations[i][0], locations[i][1]
          )
        };
        addMarker(gdc, locations[i][3], locations[i][4]);
      }
    }

  };




  $(function() {


    

    initMap($('#mappa').get(0), 14, document.locations);

    


  });

}(jQuery));